// @flow

const map = {
  'App Name': 'EcuaFirma',
  'App Link': 'https://ecuafirma.com/',
  'Support text': 'Buenas, mi nombre es {{name}}, necesito ayuda con Ecuafirma.',
  'Agent support text': 'Buenas, mi nombre es {{name}}, necesito ayuda con Ecuafirma.',
};

export const resources = {
  es: {
    translation: map,
  },
};
